import * as React from 'react';
import DatePicker from 'react-date-picker';
import { CalendarTileProperties } from 'react-calendar';
import './CustomDatePicker.scss';

export interface ICustomDatePickProps {
    id: string;
    value: NullOrUndefined<Date> | Date[];
    onChange?: (value: Date) => void;
    required?: boolean; //ensures input is not required and use the calendar values
    disabled?: boolean;
    className?: string;
    tileDisabled?: (tileProps: CalendarTileProperties) => boolean;
    clearIcon?: Nullable<JSX.Element>;
    clearCalendarIcon?: Nullable<JSX.Element>;
    minDateValue?: Date;
    maxDateValue?: Date;
}


export class CustomDatePicker extends React.Component<ICustomDatePickProps> {
    constructor(props: ICustomDatePickProps) {
        super(props);
    }

    render(): React.ReactNode {
        return (
            <div className="custom-date-picker">
                <DatePicker
                    value={this.props.value}
                    onChange={this.props.onChange}
                    required={this.props.required}
                    disabled={this.props.disabled}
                    className={this.props.className}
                    dayPlaceholder="DD"
                    monthPlaceholder="MM"
                    yearPlaceholder="YYYY"
                    tileDisabled={this.props.tileDisabled}
                    minDate={this.props.minDateValue}
                    maxDate={this.props.maxDateValue}
                    clearIcon={this.props.clearIcon}
                    calendarIcon={this.props.clearCalendarIcon}
                />
            </div>
        );
    }
}